import { render, staticRenderFns } from "./Calendario.vue?vue&type=template&id=a277ad50&scoped=true"
import script from "./Calendario.vue?vue&type=script&lang=ts"
export * from "./Calendario.vue?vue&type=script&lang=ts"
import style0 from "./Calendario.vue?vue&type=style&index=0&id=a277ad50&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a277ad50",
  null
  
)

export default component.exports